"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelSourceHandler = void 0;
const TERM_EXPRESSION_MAP = {
    "calculate-fn": "calculate",
    "relevant-fn": "relevant",
    "required-fn": "required",
    "readonly-fn": "readonly",
};
const VALIDATION_SET_MAP = {
    min: ["min", "text"],
    "min-fn": ["min", "syntax"],
    max: ["max", "text"],
    "max-fn": ["max", "syntax"],
};
const stubLocation = {
    tagName: "",
    attributes: {},
    location: {
        line: 0,
        col: 0,
        start: 0,
        end: 0,
    },
};
class FormModelSourceHandler {
    type = "source";
    context = {
        inFormModel: false,
        elementArray: [],
        metaNesting: [],
    };
    model = {
        type: "model-root",
        element: stubLocation,
        terms: {},
        iterables: {},
        meta: {},
        xmlns: "",
    };
    reporter;
    constructor(reporter) {
        this.reporter = reporter;
    }
    onopen = (node, location, attributeLocations) => {
        if (node.name === "FormModel") {
            this.context.inFormModel = true;
            this.model.element = {
                tagName: node.name,
                location,
                attributes: attributeLocations,
            };
            this.model.xmlns = node.attributes.xmlns;
            this.context.elementArray.push(this.model.element);
            return;
        }
        if (!this.context.inFormModel) {
            return;
        }
        const element = {
            tagName: node.name,
            location,
            attributes: attributeLocations,
        };
        this.context.elementArray.push(element);
        if (node.name === "term") {
            this.context.term = {
                type: "term",
                element,
            };
            this.context.termName = node.attributes.name;
            return;
        }
        if (node.name === "iterable") {
            this.context.iterable = {
                type: "iterable",
                element,
                terms: {},
            };
            this.context.iterableName = node.attributes.name;
        }
        if (node.name === "metatable" ||
            node.name === "metalist" ||
            node.name === "meta") {
            const rootTable = this.context.term
                ? this.context.term.meta || (this.context.term.meta = {})
                : this.model.meta;
            let currentTable = rootTable;
            for (const metaNode of this.context.metaNesting) {
                let childTable;
                if (metaNode.type === "metalist-item" && Array.isArray(currentTable)) {
                    childTable = currentTable[metaNode.index];
                }
                if (metaNode.type === "metatable-item" &&
                    !Array.isArray(currentTable)) {
                    childTable = currentTable[metaNode.name];
                }
                if (typeof childTable !== "object" ||
                    (childTable.type !== "metatable" && childTable.type !== "metalist")) {
                    return;
                }
                currentTable = childTable.item;
            }
            if (node.name === "metatable") {
                if (Array.isArray(currentTable)) {
                    currentTable.push({
                        type: "metatable",
                        item: {},
                        element,
                    });
                    this.context.metaNesting.push({
                        type: "metalist-item",
                        index: currentTable.length - 1,
                        element,
                    });
                }
                else {
                    currentTable[node.attributes.name] = {
                        type: "metatable",
                        item: {},
                        element,
                    };
                    this.context.metaNesting.push({
                        type: "metatable-item",
                        name: node.attributes.name,
                        element,
                    });
                }
            }
            if (node.name === "metalist") {
                if (Array.isArray(currentTable)) {
                    currentTable.push({
                        type: "metalist",
                        item: [],
                        element,
                    });
                    this.context.metaNesting.push({
                        type: "metalist-item",
                        index: currentTable.length - 1,
                        element,
                    });
                }
                else {
                    currentTable[node.attributes.name] = {
                        type: "metalist",
                        item: [],
                        element,
                    };
                    this.context.metaNesting.push({
                        type: "metatable-item",
                        name: node.attributes.name,
                        element,
                    });
                }
            }
            if (node.name === "meta") {
                if (Array.isArray(currentTable)) {
                    currentTable.push({
                        type: "meta",
                        element,
                    });
                }
                else {
                    currentTable[node.attributes.name] = { type: "meta", element };
                }
            }
            return;
        }
        if (node.name === "compose") {
            if (!this.model.composables) {
                this.model.composables = [];
            }
            this.model.composables.push({
                type: "model-composable",
                element,
            });
            return;
        }
        if (this.context.term) {
            if (node.name === "enum") {
                this.context.enum = {
                    type: "term-enum",
                    element,
                };
                return;
            }
            if (node.name === "validation") {
                this.context.validation = {
                    type: "term-validation",
                    element,
                };
                return;
            }
            if (node.name === "event") {
                this.context.event = {
                    type: "term-event",
                    element,
                    statements: [],
                };
            }
        }
    };
    ontext = () => undefined;
    onclose = (node) => {
        if (!this.context.inFormModel) {
            return;
        }
        const element = this.context.elementArray.pop();
        if (!element || element.tagName !== node.name) {
            return;
        }
        if (node.name === "FormModel") {
            this.context.inFormModel = false;
            return;
        }
        if (node.name === "metatable" || node.name === "metalist") {
            this.context.metaNesting.pop();
            return;
        }
        if (this.context.iterable && this.context.iterableName) {
            if (node.name === "term" && this.context.term && this.context.termName) {
                if (this.context.iterable.terms[this.context.termName]) {
                    this.reporter({
                        message: `The "${this.context.iterableName}" iterable already has a term named "${this.context.termName}"`,
                        location: element.attributes.name,
                        level: 1,
                    });
                }
                this.context.iterable.terms[this.context.termName] = this.context.term;
                delete this.context.term;
                delete this.context.termName;
                return;
            }
            if (node.name === "iterable") {
                if (this.model.iterables[this.context.iterableName]) {
                    this.reporter({
                        message: `The model already has an iterable named "${this.context.iterableName}"`,
                        location: element.attributes.name,
                        level: 1,
                    });
                }
                if (!this.context.iterableCount) {
                    delete this.context.iterable;
                    delete this.context.iterableName;
                    return;
                }
                this.model.iterables[this.context.iterableName] = {
                    ...this.context.iterable,
                    count: this.context.iterableCount,
                };
                delete this.context.iterable;
                delete this.context.iterableName;
                delete this.context.iterableCount;
                return;
            }
            if (node.name === "count-fn") {
                this.context.iterableCount = element;
                return;
            }
        }
        if (this.context.term && this.context.termName) {
            if (node.name === "term") {
                if (this.model.terms[this.context.termName]) {
                    this.reporter({
                        message: `The model already has a term named "${this.context.termName}"`,
                        location: element.attributes.name,
                        level: 1,
                    });
                }
                this.model.terms[this.context.termName] = this.context.term;
                delete this.context.term;
                delete this.context.termName;
                return;
            }
            if (this.context.validation) {
                if (node.name === "validation") {
                    if (!this.context.term.validationList) {
                        this.context.term.validationList = [];
                    }
                    this.context.term.validationList.push(this.context.validation);
                    delete this.context.validation;
                    return;
                }
                // Handle all validation nodes
                const validationNode = VALIDATION_SET_MAP[node.name];
                if (validationNode) {
                    if (this.context.validation[validationNode[0]]) {
                        return;
                    }
                    this.context.validation[validationNode[0]] = element;
                }
                return;
            }
            if (this.context.event) {
                if (node.name === "event") {
                    if (!this.context.term.events) {
                        this.context.term.events = [];
                    }
                    this.context.term.events.push(this.context.event);
                    delete this.context.event;
                    return;
                }
                if (node.name === "suppose-fn") {
                    this.context.event.statements.push({
                        type: "term-event-suppose",
                        element,
                    });
                    return;
                }
                if (node.name === "when-fn") {
                    this.context.event.statements.push({
                        type: "term-event-when",
                        element,
                    });
                    return;
                }
                if (node.name === "set" || node.name === "set-fn") {
                    this.context.event.statements.push({
                        type: "term-event-set",
                        element,
                    });
                    return;
                }
            }
            if (node.name === "label" || node.name === "label-fn") {
                if (this.context.term.label) {
                    return;
                }
                this.context.term.label = element;
                return;
            }
            if (node.name === "enum") {
                if (!this.context.term.enums) {
                    this.context.term.enums = [];
                }
                if (!this.context.enum) {
                    return;
                }
                this.context.term.enums.push(this.context.enum);
                delete this.context.enum;
                return;
            }
            if (node.name === "enums-fn") {
                this.context.term.enumsFn = element;
                return;
            }
            // Handle all term expressions nodes
            const expression = TERM_EXPRESSION_MAP[node.name];
            if (expression) {
                if (expression === "relevant" &&
                    this.context.enum &&
                    this.context.elementArray.at(-1)?.tagName === "enum") {
                    this.context.enum.relevant = element;
                    return;
                }
                this.context.term[expression] = element;
                return;
            }
        }
        if (node.name === "key-fn") {
            if (this.context.term) {
                this.context.term.key = element;
            }
            else if (this.context.iterable) {
                this.context.iterable.key = element;
            }
            else {
                this.model.key = element;
            }
            return;
        }
    };
}
exports.FormModelSourceHandler = FormModelSourceHandler;
//# sourceMappingURL=handler-source-map.js.map